import React from 'react';
import NotFound from '../components/notFound/NotFound';
import GlobalStyled from '../components/app/StyledApp'

const NotFoundPage = () => {
    return (
        <>
        <GlobalStyled />
        <NotFound />
        </>
    )
}

export default NotFoundPage
